import React from "react";
import Layout from "../common/Layout";
import Breadcrumb from "../common/breadcrumb/Breadcrumb";
import ContactUsForm from "../components/contact-us-form/ContactUsForm";
import { Helmet } from "react-helmet";

const OfficeLocations = [
  {
    title: "Head Office Turkey",
    address:
      "Gayrettepe Mahallesi, Ömer Beşiktaş Sk. No: 2,<br />34400 Kağıthane / Beşiktaş, İstanbul, Türkiye",
    phone: null,
    email: "info@ironwallx.com<br />support@ironwallx.com",
  },
  {
    title: "Dubai Office",
    country: "United Arab Emirates",
    address:
      "Sheikh Zayed Road,<br />Marsa Dubai, Dubai Marina,<br />Dubai, United Arab Emirates",
    phone: "+971 56 202 0911",
    email: null,
  },
  {
    title: "Cambodia Office",
    address: "Street No. 1003,<br />Phnom Penh, Cambodia",
    phone: "+855 78 862 414",
    email: null,
  },
  // {
  //     title: "India Office New Delhi",
  //     address: "180/2, 2nd Floor,<br />Opposite Fortis Hospital,<br />Sarai Jullena, New Friends Colony,<br />New Delhi 110025, India",
  //     phone: "+91 92115 09389",
  //     email: null
  // },
  //   {
  //     title: "India Office Rampur (Uttar Pradesh)",
  //     address: "256, Ground Floor, Opposite Axis Bank, Zeena Inayat Khan Road, Near Hamid School, Rampur, Uttar Pradesh 244901, India",
  //     phone: "+91 85128 20964",
  //     email: null
  // }
];

const ContactUs = () => {
  return (
    <>
      <Helmet>
        <title>
          Contact Us || Iron Wall X - Professional Security Services Turkey
        </title>
        <meta
          name="description"
          content="Get in touch with Iron Wall X for professional security services in Turkey. 24/7 support, free consultations, and rapid response teams ready to protect your assets."
        />
        <meta
          name="keywords"
          content="contact security company Turkey, security services Istanbul, security quote Turkey, professional security contact, Iron Wall X contact, Turkish security firm"
        />
      </Helmet>
      <Layout>
        <Breadcrumb
          pageTitle="Contact Us"
          rootPath="/"
          parentPath="Home"
          currentPath="Contact"
        />
        {/* Contact Page Section Start */}
        <div className="contact-page-sec pt-100 pb-100">
          <div className="container">
            <div className="row mb-5">
              <div className="col-md-12">
                <div className="contact-field">
                  <h2>Send Us a Message</h2>
                  <ContactUsForm />
                </div>
              </div>
            </div>

            <div className="row mt-5">
              <div className="col-md-12 mb-4">
                <h2 className="text-center">Our Office Locations</h2>
                <p className="text-center">
                  We operate through multiple international offices to serve our
                  clients efficiently across regions.
                </p>
              </div>
            </div>

            <div className="row">
              {OfficeLocations.map((office, i) => (
                <div key={i} className="col-md-6 col-lg-4 mb-4">
                  <div className="contact-info">
                    <div className="contact-info-item">
                      <div className="contact-info-text">
                        <h3>{office.title}</h3>
                        {office.country && <h5>{office.country}</h5>}

                        {office.address && (
                          <div className="mb-3">
                            <strong>Address:</strong>
                            <br />
                            <span
                              dangerouslySetInnerHTML={{
                                __html: office.address,
                              }}
                            />
                          </div>
                        )}

                        {office.phone && (
                          <div className="mb-3">
                            <strong>Phone:</strong>
                            <br />
                            <span>{office.phone}</span>
                          </div>
                        )}

                        {office.email && (
                          <div className="mb-3">
                            <strong>E-mail:</strong>
                            <br />
                            <span
                              dangerouslySetInnerHTML={{ __html: office.email }}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        {/* Contact Page Section End */}
      </Layout>
    </>
  );
};

export default ContactUs;
